import qs from 'query-string';
import SuperFetchV2 from '../../superFetchV2';
import { GetProductListRequest } from './type';
import {
  ProductResponseDto,
  ProductsExcelUploadResponseDto,
  ProductsResponseBodyDto,
} from '../../../types/api/products';
import {
  CustomFieldDefinitionsResponseDto,
  ProductCustomFieldsResponseDto,
} from '../../../types/api/product-custom-fields';
import { CustomAttributePayload } from '../../../types/product/customAttribute';

class ProductApiV2 {
  /**
   *  상품 리스트 조회
   */
  getProductList = (data: GetProductListRequest): Promise<ProductsResponseBodyDto> =>
    SuperFetchV2.get(`/products?${qs.stringify(data, { skipNull: true, skipEmptyString: true })}`);
  /**
   *  상품 상세 조회
   */
  fetchProductInfo = (productId: number): Promise<ProductResponseDto> => SuperFetchV2.get(`/products/${productId}`);
  getProductCustomFieldDefinitions = (): Promise<CustomFieldDefinitionsResponseDto> =>
    SuperFetchV2.get('/product-custom-fields/definitions');

  getProductCustomFields = (productId: number): Promise<ProductCustomFieldsResponseDto> =>
    SuperFetchV2.get(`/product-custom-fields/${productId}`);

  updateProductCustomFields = (
    productId: number,
    payload: CustomAttributePayload,
  ): Promise<ProductCustomFieldsResponseDto> => SuperFetchV2.patch(`/product-custom-fields/${productId}`, payload);
  uploadExcel = (file: File): Promise<ProductsExcelUploadResponseDto> => {
    const formData = new FormData();
    formData.append('file', file);
    return SuperFetchV2.post('/products/excel-upload', formData);
  };
  downloadExcel = (productIdList: number[]): Promise<{ adminEmail: string }> =>
    SuperFetchV2.post('/products/excel-download', { productIds: productIdList });
}

export default new ProductApiV2();
